(() => {
  function initCarousel(root) {
    const track = root.querySelector("[data-ols-track]");
    const slides = Array.from(root.querySelectorAll("[data-ols-slide]"));
    const prevBtn = root.querySelector("[data-ols-prev]");
    const nextBtn = root.querySelector("[data-ols-next]");
    const dotsWrap = root.querySelector("[data-ols-dots]");

    if (!track || slides.length === 0) return;

    // Build dots (one per slide group/page)
    function getPageSize() {
      // How many slides are visible at once?
      const slide = slides[0];
      const trackRect = track.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();
      const perView = Math.max(1, Math.round(trackRect.width / slideRect.width));
      return perView;
    }

    function getPages() {
      const perView = getPageSize();
      return Math.ceil(slides.length / perView);
    }

    function scrollToPage(pageIndex) {
      const perView = getPageSize();
      const slideIndex = Math.min(slides.length - 1, pageIndex * perView);
      slides[slideIndex].scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
    }

    function currentPage() {
      const perView = getPageSize();
      const trackLeft = track.scrollLeft;
      const slideWidth = slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      const approxIndex = Math.round(trackLeft / slideWidth);
      return Math.floor(approxIndex / perView);
    }

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = "";
      const pages = getPages();
      for (let i = 0; i < pages; i++) {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "ols-carousel__dot";
        b.setAttribute("aria-label", `Go to slide group ${i + 1}`);
        b.addEventListener("click", () => scrollToPage(i));
        dotsWrap.appendChild(b);
      }
      updateUI();
    }

    function updateUI() {
      const page = currentPage();
      const pages = getPages();

      // Buttons
      if (prevBtn) prevBtn.disabled = page <= 0;
      if (nextBtn) nextBtn.disabled = page >= pages - 1;

      // Dots
      if (dotsWrap) {
        Array.from(dotsWrap.children).forEach((dot, i) => {
          dot.classList.toggle("is-active", i === page);
        });
      }
    }

    // Controls
    prevBtn && prevBtn.addEventListener("click", () => scrollToPage(Math.max(0, currentPage() - 1)));
    nextBtn && nextBtn.addEventListener("click", () => scrollToPage(Math.min(getPages() - 1, currentPage() + 1)));

    // Update on scroll and resize
    let raf = 0;
    track.addEventListener("scroll", () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateUI);
    });

    window.addEventListener("resize", () => {
      renderDots();
    });

    renderDots();
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-ols-carousel]").forEach(initCarousel);
  });
})();
